export const SEVERITY_LEVELS = {
    CRITICAL: 'critical',
    WARNING: 'warning',
    INFORMATIONAL: 'informational'
};

export const IMPACT_AREAS = {
    AVAILABILITY: 'availability',
    CAPACITY: 'capacity',
    CONFIGURATION: 'configuration',
    PERFORMANCE: 'performance',
    PROTECTION: 'protection',
    SECURITY: 'security'
};

export const SUPPORTED_RECURRENCE_TYPES = {
    NONE: 'none',
    DAILY: 'daily',
    WEEKLY: 'weekly',
    MONTHLY: 'monthly',
    YEARLY: 'yearly'
};

// This is a mapping of the Alerts and Notifications supported service keys to the corresponding API expected value.
const SUPPORTED_SERVICES = {
    'ontap': 'ONTAP_MANAGEMENT',
    'cloud-backup-ubr': 'BACKUP_AND_RECOVERY',
    'storage-grid': 'STORAGE_GRID',
    'eseries': 'E_SERIES',
    'console': 'CONSOLE'
};

export const getSupportedServicesOptions = (services) => {
    return services ? services.filter(service => Object.keys(SUPPORTED_SERVICES).includes(service.key)).map(service => ({ label: service.name, value: SUPPORTED_SERVICES[service.key], tooltip: service.name })).sort((a, b) => a.label.localeCompare(b.label)) : [];
}

export const SMTP_CERT_MAX_FILE_SIZE_BYTES = 51200;
export const SMTP_CERT_MAX_FILE_SIZE_KB = SMTP_CERT_MAX_FILE_SIZE_BYTES / 1024;

export const getUploadedFileSizeBytes = (uploadedFile) => {
    if (!uploadedFile) {
        return 0;
    }

    if (typeof uploadedFile.fileSize === 'number') {
        return uploadedFile.fileSize;
    }

    return 0;
};

export const getErrorForDateRange = (from, to, t) => {
    if (!from || !to) {
        return {
            type: "error",
            message: t('date_range_required')
        };
    }
    if (new Date(from).getTime() >= new Date(to).getTime()) {
        return {
            type: "error",
            message: t('date_range_greater_required')
        };
    }
    return null;
};
